"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slotTypeInfo = exports.moduleLayoutsV2 = void 0;
/* eslint-disable no-restricted-syntax */
/* eslint-disable sort-keys */

// IMPORTANT! Do not change the module key as it is also PK in poku service,
// do change the module name in selectbox, use "displayName" property

var slotTypeInfo = exports.slotTypeInfo = {
  // 352
  L_165_90_655: {
    width: 165,
    height: 90,
    depth: 655,
    altName: '352-1U-1/2',
    displayWidth: 208,
    displayHeight: 111
  },
  L_400_90_655: {
    width: 400,
    height: 90,
    depth: 655,
    altName: '352-1U',
    displayWidth: 416,
    displayHeight: 111
  },
  L_400_200_655: {
    width: 400,
    height: 200,
    depth: 655,
    altName: '352-2U',
    displayWidth: 416,
    displayHeight: 222
  },
  L_400_430_655: {
    width: 400,
    height: 430,
    depth: 655,
    altName: '352-4U',
    displayWidth: 416,
    displayHeight: 444
  },
  'CC352-4U-POS': {
    width: 400,
    height: 430,
    depth: 655,
    altName: '352-4U-POS',
    storable: false,
    displayWidth: 416,
    displayHeight: 444
  },
  L_400_650_655: {
    width: 400,
    height: 650,
    depth: 655,
    altName: '352-6U',
    displayWidth: 416,
    displayHeight: 666
  },
  'CC352-6U-CC': {
    width: 400,
    height: 650,
    depth: 655,
    altName: '352-6U-CC',
    storable: false,
    displayWidth: 416,
    displayHeight: 666
  },
  L_400_880_655: {
    width: 400,
    height: 650,
    depth: 655,
    altName: '352-8U',
    displayWidth: 416,
    displayHeight: 888
  }
};

/*
    Module layouts V2
*/
var moduleLayoutsV2 = exports.moduleLayoutsV2 = {};
function getSlotTypeFromAltName(altName) {
  for (var id in slotTypeInfo) {
    if (slotTypeInfo[id].altName === altName) {
      return id;
    }
  }
  for (var _id in slotTypeInfo) {
    if (_id === altName) {
      return _id;
    }
  }
  throw new Error("Slot type not found by altName ".concat(altName));
}
moduleLayoutsV2['354 12-door (5+7)'] = {
  slots: [{
    type: getSlotTypeFromAltName('352-4U'),
    altName: '352-4U',
    locks: {
      1: {
        seqNr: 1,
        ioCounter: 0
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-4U'),
    altName: '352-4U',
    locks: {
      1: {
        seqNr: 2,
        ioCounter: 5
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 3,
        ioCounter: 1
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 4,
        ioCounter: 6
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 5,
        ioCounter: 2
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 6,
        ioCounter: 7
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 7,
        ioCounter: 3
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 8,
        ioCounter: 8
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-6U'),
    altName: '352-6U',
    locks: {
      1: {
        seqNr: 9,
        ioCounter: 4
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 10,
        ioCounter: 9
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 11,
        ioCounter: 10
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-4U'),
    altName: '352-4U',
    locks: {
      1: {
        seqNr: 12,
        ioCounter: 11
      }
    }
  }],
  displayName: '354 12-door (5+7)',
  towerWidth: 832
};
moduleLayoutsV2['354 16-door (8+8)'] = {
  slots: [{
    type: getSlotTypeFromAltName('352-4U'),
    altName: '352-4U',
    locks: {
      1: {
        seqNr: 1,
        ioCounter: 0
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-4U'),
    altName: '352-4U',
    locks: {
      1: {
        seqNr: 2,
        ioCounter: 8
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 3,
        ioCounter: 1
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 4,
        ioCounter: 9
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 5,
        ioCounter: 2
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 6,
        ioCounter: 10
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 7,
        ioCounter: 3
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 8,
        ioCounter: 11
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 9,
        ioCounter: 4
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 10,
        ioCounter: 12
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 11,
        ioCounter: 5
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 12,
        ioCounter: 13
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 13,
        ioCounter: 6
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 14,
        ioCounter: 14
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-4U'),
    altName: '352-4U',
    locks: {
      1: {
        seqNr: 15,
        ioCounter: 7
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-4U'),
    altName: '352-4U',
    locks: {
      1: {
        seqNr: 16,
        ioCounter: 15
      }
    }
  }],
  displayName: '354 16-door (8+8)',
  towerWidth: 832
};
moduleLayoutsV2['354 32-door (19+13)'] = {
  slots: [{
    type: getSlotTypeFromAltName('352-4U'),
    altName: '352-4U',
    locks: {
      1: {
        seqNr: 1,
        ioCounter: 0
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-4U'),
    altName: '352-4U',
    locks: {
      1: {
        seqNr: 2,
        ioCounter: 19
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 3,
        ioCounter: 1
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 4,
        ioCounter: 2
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 5,
        ioCounter: 20
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 6,
        ioCounter: 21
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 7,
        ioCounter: 3
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 8,
        ioCounter: 4
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 9,
        ioCounter: 22
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 10,
        ioCounter: 23
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 11,
        ioCounter: 5
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 12,
        ioCounter: 6
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 13,
        ioCounter: 24
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 14,
        ioCounter: 25
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 15,
        ioCounter: 7
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 16,
        ioCounter: 8
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 17,
        ioCounter: 26
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 18,
        ioCounter: 27
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 19,
        ioCounter: 9
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 20,
        ioCounter: 10
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 21,
        ioCounter: 28
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 22,
        ioCounter: 11
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 23,
        ioCounter: 12
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 24,
        ioCounter: 13
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 25,
        ioCounter: 14
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 26,
        ioCounter: 29
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 27,
        ioCounter: 15
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U-1/2'),
    altName: '352-1U-1/2',
    locks: {
      1: {
        seqNr: 28,
        ioCounter: 16
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 29,
        ioCounter: 17
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 30,
        ioCounter: 30
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 31,
        ioCounter: 18
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 32,
        ioCounter: 31
      }
    }
  }],
  displayName: '354 32-door (19+13)',
  towerWidth: 832
};
moduleLayoutsV2['354 20-door (11+9)'] = {
  slots: [{
    type: getSlotTypeFromAltName('352-4U'),
    altName: '352-4U',
    locks: {
      1: {
        seqNr: 1,
        ioCounter: 0
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-4U'),
    altName: '352-4U',
    locks: {
      1: {
        seqNr: 2,
        ioCounter: 11
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 3,
        ioCounter: 1
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 4,
        ioCounter: 12
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 5,
        ioCounter: 2
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 6,
        ioCounter: 13
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 7,
        ioCounter: 3
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 8,
        ioCounter: 14
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 9,
        ioCounter: 4
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 10,
        ioCounter: 15
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 11,
        ioCounter: 5
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 12,
        ioCounter: 16
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 13,
        ioCounter: 6
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 14,
        ioCounter: 7
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 15,
        ioCounter: 17
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-1U'),
    altName: '352-1U',
    locks: {
      1: {
        seqNr: 16,
        ioCounter: 8
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 17,
        ioCounter: 9
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 18,
        ioCounter: 18
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 19,
        ioCounter: 10
      }
    }
  }, {
    type: getSlotTypeFromAltName('352-2U'),
    altName: '352-2U',
    locks: {
      1: {
        seqNr: 20,
        ioCounter: 19
      }
    }
  }],
  displayName: '354 20-door (11+9)',
  towerWidth: 832
};